import React from 'react';
import { X, GitBranch, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import '../../component-styles/RecordPages.css';

export default function CreditFolioModal({ credit, projectId, onClose }) {
  if (!credit) return null;

  const isRefunded = credit.status === 'refunded';
  const refundedDate = credit.refundedAt ? new Date(credit.refundedAt).toLocaleDateString() : null;

  return (
    <div className="folio-overlay" onClick={onClose}>
      <div className="folio-modal" onClick={(e) => e.stopPropagation()}>
        <button className="folio-close" onClick={onClose}>
          <X size={20} />
        </button>

        <h3 className="folio-title">
          {credit.creditNumber}
          <span className="folio-sub">{credit.description}</span>

          {isRefunded && <span className="folio-badge-refunded">Refunded</span>}
        </h3>

        <div className="folio-summary">
          <div>
            <label>Total</label>
            <div>${credit.total.toLocaleString()}</div>
          </div>

          <div>
            <label>{isRefunded ? 'Refunded Amount' : 'Available'}</label>
            <div>
              $
              {isRefunded
                ? credit.total.toLocaleString()
                : credit.availableBalance.toLocaleString()}
            </div>
          </div>
        </div>

        {isRefunded && (
          <>
            <h4 className="folio-section-label">Refund Details</h4>

            <div className="folio-refund-box">
              <p>
                <strong>Status:</strong> Refunded
              </p>
              <p>
                <strong>Date Refunded:</strong> {refundedDate || '—'}
              </p>
              <p>
                <strong>Amount:</strong> ${credit.total.toLocaleString()}
              </p>

              <p className="folio-refund-note">
                This credit has been fully refunded and can no longer be applied.
              </p>
            </div>
          </>
        )}

        {!isRefunded && (
          <>
            <h4 className="folio-section-label">Applied To</h4>

            <div className="folio-applied-list">
              {credit.appliedDocs?.length === 0 && (
                <div className="folio-empty">No applications yet.</div>
              )}

              {credit.appliedDocs?.map((doc, idx) => {
                const type = doc.docType.toLowerCase();
                let url = '#';

                if (type === 'retainer') {
                  url = `/projects/${projectId}/retainers/${doc.docId}`;
                } else if (type === 'invoice') {
                  url = `/projects/${projectId}/invoices/${doc.docId}`;
                } else if (type === 'proposal') {
                  url = `/projects/${projectId}/proposals/${doc.docId}`;
                } else if (type === 'purchase-order') {
                  url = `/projects/${projectId}/purchase-orders/${doc.docId}`;
                } else if (type === 'timebilling') {
                  url = `/projects/${projectId}/timebilling-invoices/${doc.docId}`;
                }

                return (
                  <Link to={url} key={idx} className="folio-applied-row">
                    <GitBranch size={16} className="folio-row-icon" />

                    <div className="folio-row-text">
                      <b>{doc.docNumber}</b> —{' '}
                      {type === 'timebilling'
                        ? 'Time Billing Invoice'
                        : doc.docType.charAt(0).toUpperCase() + doc.docType.slice(1)}
                      <span style={{ marginLeft: 4 }}>
                        (
                        {doc.amount.toLocaleString('en-US', {
                          style: 'currency',
                          currency: 'USD',
                        })}
                        )
                      </span>
                    </div>

                    <ExternalLink size={14} className="folio-open-icon" />
                  </Link>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
